// Override Settings
var bcSfFilterSettings = {
    general: {
        limit: 42,
        /* Optional */
        // loadProductFirst: true,
    }
};

// Declare Templates
var bcSfFilterTemplate = {
    'soldOutClass': 'sold-out',
    'saleClass': 'on-sale',
    'soldOutLabelHtml': '<div>' + bcSfFilterConfig.label.sold_out + '</div>',
    'saleLabelHtml': '<div>' + bcSfFilterConfig.label.sale + '</div>',
    'vendorHtml': '<div>{{itemVendorLabel}}</div>',

    // Grid Template
    'productGridItemHtml': '<div class="grid__item large-up--one-third">' +
        '<div class="{{soldOutClass}} {{saleClass}}">' +
        '<a href="{{itemUrl}}" class="grid-link">' +
        '<span class="grid-link__image {{imageSoldOutClass}} grid-link__image--product">' +
        '{{itemSaleLabel}}' +
        '{{itemSoldOutLabel}}' +
        '<span class="grid-link__image-centered"><img src="{{imgUrl}}" alt="{{itemTitle}}" /></span>' +
        '</span>' +
        '<p class="grid-link__title">{{itemTitle}}</p>' +
        '{{itemVendor}}' +
        '{{itemPrice}}' +
        '</a>' +
        '</div>' +
        '</div>',

    // Pagination Template
    'previousActiveHtml': '<li><a href="{{itemUrl}}">&larr;</a></li>',
    'previousDisabledHtml': '<li class="disabled"><span>&larr;</span></li>',
    'nextActiveHtml': '<li><a href="{{itemUrl}}">&rarr;</a></li>',
    'nextDisabledHtml': '<li class="disabled"><span>&rarr;</span></li>',
    'pageItemHtml': '<li><a href="{{itemUrl}}">{{itemTitle}}</a></li>',
    'pageItemSelectedHtml': '<li><span class="active">{{itemTitle}}</span></li>',
    'pageItemRemainHtml': '<li><span>{{itemTitle}}</span></li>',
    'paginateHtml': '<ul class="pagination-custom">{{previous}}{{pageItems}}{{next}}</ul>',

    // Sorting Template
    'sortingHtml': '<label class="mobile-only">' + bcSfFilterConfig.label.sorting + '</label><select class="collection-sort__input">{{sortingItems}}</select>',
};


var bcsfTemplates = null;

var bcsfCompileTemplates = function () {
    bcsfTemplates = {
        productCard: Handlebars.compile(document.getElementById("collection-product__card").innerHTML)
    };
}



/************************** BUILD PRODUCT LIST **************************/

// Build Product Grid Item
BCSfFilter.prototype.buildProductGridItem = function (data, index) {
    // don't compile templates unless needed in order to preserve javascript runtime

    /*** Prepare data ***/
    var images = data.images_info;
    // Displaying price base on the policy of Shopify, have to multiple by 100
    var soldOut = !data.available; // Check a product is out of stock
    var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    var priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Get First Variant (selected_or_first_available_variant)

    const variantsToBeSorted = data.variants;

    // Get lowest price first and then highest inventory of those lowest prices
    const variantsByPriceThenInventory = variantsToBeSorted.sort(function (a, b) {
        return a.price - b.price || b.inventory_quantity - a.inventory_quantity
    });

    var firstVariant = variantsByPriceThenInventory.find(
     (variant) => variant.inventory_quantity > 0
    );

    if(!firstVariant){
        firstVariant = data['variants'][0];
        if (getParam('variant') !== null && getParam('variant') != '') {
        var paramVariant = data.variants.filter(function (e) {
            return e.id == getParam('variant');
        });
        if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
        } else {
        for (var i = 0; i < data['variants'].length; i++) {
            if (data['variants'][i].available) {
            firstVariant = data['variants'][i];
            break;
            }
        }
        }
    }

    var inventoryQty = 0;
    for (var i = 0; i < data['variants'].length; i++) {
        if (data['variants'][i].available) {
            inventoryQty = inventoryQty + data['variants'][i].inventory_quantity;
        }
    }

    /*** End Prepare data ***/

    const selectedCompareAtPrice = firstVariant.compare_at_price && firstVariant.compare_at_price / 100;
    const slectedPrice = firstVariant.price / 100;

    var tags = data.tags.filter(function (val) { return val.indexOf('badge:') > -1 });
    var tag = tags[0] && tags[0].split(':');

    var countryTag = data.tags.filter(function (val) { return val.indexOf('country:') > -1 });
    var country = countryTag[0] ? countryTag[0].split(':')[1].trim() : null;

    var designerTag = data.tags.filter(function (val) { return val.indexOf('designer:') > -1 });
    var designer = designerTag[0] ? designerTag[0].split(':')[1].trim() : null;

    var isInstoreOnly = data.tags.filter(function (val) { return val.indexOf('non-transactional') > -1 });

    const price = Number(slectedPrice).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    const prev_price = selectedCompareAtPrice && Number(selectedCompareAtPrice).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    var item = {
        imageUrl: firstVariant.image || data.images_info[0].src,
        image2Url: data.images_info[1] ? data.images_info[1].src : null,
        url: '/products/' + data.handle + '?variant=' + firstVariant.id,
        name: data.title,
        prev_price,
        price,
        badgeText: tag ? tag[1].trim() : null,
        badgeBullet: tag ? tag[2].trim() : null,
        country: country,
        designer: designer,
        vendor: data.vendor,
        isInStore: isInstoreOnly,
        isPriceVaries: data.price_min < data.price_max,
        inventoryQty: inventoryQty,
    };

    if (!bcsfTemplates) {
        bcsfCompileTemplates();
    }
    itemHtml = bcsfTemplates.productCard(item)

    return itemHtml;
};

// Build Product List Item
BCSfFilter.prototype.buildProductListItem = function (data) {
    // // Add Description
    // var itemDescription = jQ('<p>' + data.body_html + '</p>').text();
    // // Truncate by word
    // itemDescription = (itemDescription.split(" ")).length > 51 ? itemDescription.split(" ").splice(0, 51).join(" ") + '...' : itemDescription.split(" ").splice(0, 51).join(" ");
    // // Truncate by character
    // itemDescription = itemDescription.length > 350 ? itemDescription.substring(0, 350) + '...' : itemDescription.substring(0, 350);
    // itemHtml = itemHtml.replace(/{{itemDescription}}/g, itemDescription);
};

// Customize data to suit the data of Shopify API
BCSfFilter.prototype.prepareProductData = function (data) {
    for (var k in data) {
        // Add Options
        var optionsArr = [];
        for (var i in data[k]['options_with_values']) {
            optionsArr.push(data[k]['options_with_values'][i]['name']);
        }
        data[k]['options'] = optionsArr;

        // Customize variants
        for (var i in data[k]['variants']) {
            var variantOptionArr = [];
            var count = 1;
            var variant = data[k]['variants'][i];
            // Add Options
            var variantOptions = variant['merged_options'];
            if (Array.isArray(variantOptions)) {
                for (var j = 0; j < variantOptions.length; j++) {
                    var temp = variantOptions[j].split(':');
                    data[k]['variants'][i]['option' + (parseInt(j) + 1)] = temp[1];
                    data[k]['variants'][i]['option_' + temp[0]] = temp[1];
                    variantOptionArr.push(temp[1]);
                }
                data[k]['variants'][i]['options'] = variantOptionArr;
            }
            data[k]['variants'][i]['compare_at_price'] = parseFloat(data[k]['variants'][i]['compare_at_price']) * 100;
            data[k]['variants'][i]['price'] = parseFloat(data[k]['variants'][i]['price']) * 100;
        }

        // Add Description
        data[k]['description'] = data[k]['body_html'];
    }
    return data;
};

/************************** END BUILD PRODUCT LIST **************************/

// Build Pagination
BCSfFilter.prototype.buildPagination = function (totalProduct) {
    if (this.getSettingValue('general.paginationType') == 'default') {
        // Get page info
        var currentPage = parseInt(this.queryParams.page);
        var totalPage = Math.ceil(totalProduct / this.queryParams.limit);

        // If it has only one page, clear Pagination
        if (totalPage == 1) {
            jQ(this.selector.bottomPagination).html('');
            return false;
        }

        if (this.getSettingValue('general.paginationType') == 'default') {
            var paginationHtml = bcSfFilterTemplate.paginateHtml;

            // Build Previous
            var previousHtml = (currentPage > 1) ? bcSfFilterTemplate.previousActiveHtml : bcSfFilterTemplate.previousDisabledHtml;
            previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage - 1));
            paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

            // Build Next
            var nextHtml = (currentPage < totalPage) ? bcSfFilterTemplate.nextActiveHtml : bcSfFilterTemplate.nextDisabledHtml;
            nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage + 1));
            paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

            // Create page items array
            var beforeCurrentPageArr = [];
            for (var iBefore = currentPage - 1; iBefore > currentPage - 2 && iBefore > 0; iBefore--) {
                beforeCurrentPageArr.unshift(iBefore);
            }
            if (currentPage - 3 > 0) {
                beforeCurrentPageArr.unshift('...');
            }
            if (currentPage - 3 >= 0) {
                beforeCurrentPageArr.unshift(1);
            }
            beforeCurrentPageArr.push(currentPage);

            var afterCurrentPageArr = [];
            for (var iAfter = currentPage + 1; iAfter < currentPage + 2 && iAfter <= totalPage; iAfter++) {
                afterCurrentPageArr.push(iAfter);
            }
            if (currentPage + 2 < totalPage) {
                afterCurrentPageArr.push('...');
            }
            if (currentPage + 2 <= totalPage) {
                afterCurrentPageArr.push(totalPage);
            }

            // Build page items
            var pageItemsHtml = '';
            var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
            for (var iPage = 0; iPage < pageArr.length; iPage++) {
                if (pageArr[iPage] == '...') {
                    pageItemsHtml += bcSfFilterTemplate.pageItemRemainHtml;
                } else {
                    pageItemsHtml += (pageArr[iPage] == currentPage) ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml;
                }
                pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
                pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, pageArr[iPage]));
            }
            paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);

            jQ(this.selector.bottomPagination).html(paginationHtml);
        }
    }
};

/************************** BUILD TOOLBAR **************************/

// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function () {
    if (bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
        jQ(this.selector.topSorting).html('');

        var sortingArr = this.getSortingList();
        if (sortingArr) {
            // Build content
            var sortingItemsHtml = '';
            for (var k in sortingArr) {
                sortingItemsHtml += '<option value="' + k + '">' + sortingArr[k] + '</option>';
            }
            var html = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
            jQ(this.selector.topSorting).html(html);

            // Set current value
            jQ(this.selector.topSorting + ' select').val(this.queryParams.sort);
        }
    }
};

// Build Display type (List / Grid / Collage)
// BCSfFilter.prototype.buildFilterDisplayType = function() {
//     var itemHtml = '<a href="' + this.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="change-view bc-sf-filter-display-grid" data-view="grid"><span class="icon-fallback-text"><i class="fa fa-th" aria-hidden="true"></i><span class="fallback-text">Grid view</span></span></a>';
//     itemHtml += '<a href="' + this.buildToolbarLink('display', 'grid', 'list') + '" title="List view" class="change-view bc-sf-filter-display-list" data-view="list"><span class="icon-fallback-text"><i class="fa fa-list" aria-hidden="true"></i><span class="fallback-text">List view</span></span></a>';
//     jQ(this.selector.topDisplayType).html(itemHtml);

//     // Active current display type
//     jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-list').removeClass('active');
//     jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-grid').removeClass('active');
//     if (this.queryParams.display == 'list') {
//         jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-list').addClass('active');
//     } else if (this.queryParams.display == 'grid') {
//         jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-grid').addClass('active');
//     }
// };

/************************** END BUILD TOOLBAR **************************/

// Add additional feature for product list, used commonly in customizing product list
BCSfFilter.prototype.buildExtrasProductList = function (data, eventType) { };

// Build additional elements
BCSfFilter.prototype.buildAdditionalElements = function (data, eventType) {
    var totalProduct = '<span> ' + bcSfFilterConfig.label.items_with_count_other + '</span>';
    if (data.total_product == 1) {
        totalProduct = '<span> ' + bcSfFilterConfig.label.items_with_count_one + '</span>';
    }
    jQ('#bc-sf-filter-total-product').html(totalProduct.replace(/{{ count }}/g, data.total_product));
};